/**
 * Minimal UI sound manager, separate from the musical AudioEngine. Owns one
 * lazily-created AudioContext and exposes named one-shot effects, so each sound
 * (and the synthesis behind it) lives in one swappable place — to change the
 * beep, edit `beep()` (or load and play a sample buffer there) and nothing else.
 */
export class SfxManager {
  private ctx: AudioContext | null = null;

  private context(): AudioContext {
    if (this.ctx === null) {
      this.ctx = new AudioContext();
    }
    return this.ctx;
  }

  resume(): void {
    void this.context().resume();
  }

  /**
   * Short rejection beep — played when an action is not allowed (e.g. clicking a
   * node that has no port able to accept the pending connection).
   */
  beep(): void {
    const ctx = this.context();
    if (ctx.state !== "running") {
      return;
    }
    const now = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "square";
    osc.frequency.setValueAtTime(180, now);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.1, now + 0.005);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.11);
    osc.connect(gain).connect(ctx.destination);
    osc.start(now);
    osc.stop(now + 0.13);
  }
}
